import StyledInsertIntoDoc from 'src/_common/quillElements/button/InsertToDoc';
import { useDispatch } from 'react-redux';
import { userClickedInsertIntoDocAction } from 'src/summarizer/actions/controlActions';

const InsertDocButton = () => {
  /* const absSummary = useSelector((state: RootState) => {
    const outputKey = getOutputKey(
      state.smzr.controls.summaryMode,
      state.smzr.controls.absLengthGauge
    );
    const isAbsType = AbsUnionGuard(state.smzr.output[outputKey]);
    return isAbsType ? (state.smzr.output[outputKey] as OutputAbs).summaryPara : '';
  }); */
  const dispatch = useDispatch();
  const outputBoxElem = document.getElementById('outputBoxSummarizer');
  let text = '';
  if (outputBoxElem) text = outputBoxElem.innerText;
  const sendDataToDoc = () => {
    if (outputBoxElem) text = outputBoxElem.innerText;
    if (text.length > 0) {
      window.parent.postMessage(
        {
          method: 'replaceText',
          text,
        },
        '*'
      );
      dispatch(userClickedInsertIntoDocAction(text));
    }
  };
  return (
    <StyledInsertIntoDoc
      // style={{ marginLeft: 0 }}
      variant="outlined"
      color="primary"
      className="insertButton-deault"
      onClick={sendDataToDoc}
    >
      Insert
    </StyledInsertIntoDoc>
  );
};

export default InsertDocButton;
